import {DefaultSchemaName} from '@app/views/admin/application-settings/models/data-source-config.model';
import {DataSourceFriendlyName, DataSourceType} from '@app/views/admin/application-settings/models/data-source-type.model';

export class FeatureToggleModel {
    defAppNames: string[];
    disabled: boolean;
    defaultSchemaList: { name: string; friendlyName: string }[];

    constructor(
        public keyName: string = '',
        public friendlyName: string = '',
        public description: string = '',
        public level: FEATURE_TOGGLE_LEVEL[] = [],
        public permissions: FEATURE_TOGGLE_PERMISSIONS[] = <FEATURE_TOGGLE_PERMISSIONS[]>[],
        public defApps: string[] = <string[]>[],
        public visible: boolean = null,
        public status: FEATURE_TOGGLE_STATUSES = null,
        public enabled: boolean = false,
        public enabledAt: any = null,
        public updatedAt: any = null,
        public schemas: string[] = <string[]>[],
        public changedByUserGuid: string = ''
    ) {
    }
}

export enum FEATURE_TOGGLE_LEVEL {
    'DISTRICT' = 'DISTRICT',
    'DISTRICT_APPLICATION' = 'DISTRICT_APPLICATION',
    'VENDOR_APPLICATION' = 'VENDOR_APPLICATION',
    'DISTRICT_VENDOR_INTEGRATION' = 'DISTRICT_VENDOR_INTEGRATION',
    'SYSTEM' = 'SYSTEM',
    'SSO_APPLICATION' = 'SSO_APPLICATION'
}

export enum FEATURE_TOGGLE_PERMISSIONS {
    'DISTRICT_ADMIN' = 'DISTRICT_ADMIN',
    'VENDOR_ADMIN' = 'VENDOR_ADMIN',
    'SYS_ADMIN' = 'SYS_ADMIN',
    'CUSTOMER_SUPPORT' = 'CUSTOMER_SUPPORT',
    'ALL' = 'ALL'
}

export const FEATURE_TOGGLE_PERMISSIONS_MAP = {
    'INSTITUTIONAL_ADMIN': 'DISTRICT_ADMIN',
    'district': 'DISTRICT_ADMIN',
    'APPLICATION_ADMIN': 'VENDOR_ADMIN',
    'app_vendor': 'VENDOR_ADMIN',
    'SYS_ADMIN': 'SYS_ADMIN',
    'root': 'SYS_ADMIN',
    'SERVICE_OPERATOR': 'CUSTOMER_SUPPORT'
};

export enum FEATURE_TOGGLE_STATUSES {
    'READY' = 'READY',
    'EXPERIMENTAL' = 'EXPERIMENTAL',
    'ENABLED' = 'ENABLED',
    'DISABLED' = 'DISABLED'
}

export const ROSTER_DATA_TOBEDELETED_STATUS_FEATURE_TOGGLE_KEY_NAME = 'ROSTER_DATA_TOBEDELETED_STATUS';
export const DIRECTORY_USERS_AS_ROSTER_DATA_FEATURE_TOGGLE_KEY_NAME = 'DIRECTORY_USERS_AS_ROSTER_DATA';
export const SP_ENTERPRISE_EDITION_FEATURE_TOGGLE_KEY_NAME = 'SP_ENTERPRIZE_EDITION';
export const GRADEBOOK_SYNC_FEATURE_TOGGLE_KEY_NAME = 'GRADEBOOK_SYNC';
export const ORG_HOST_FOR_SSO_LINK_FEATURE_TOGGLE_KEY_NAME = 'ORG_HOST_FOR_SSO_LINK';
export const ENABLE_CATEGORIES_CREATION_KEY_NAME = 'PROVISION_GRADEBOOK_TO_POWER_SCHOOL';
export const AUTO_PROVISION_ALLOWED_FOR_VENDOR = 'AUTO_PROVISION_ALLOWED_FOR_VENDOR';
export const ENABLE_SUPPORT_INCREMENTAL_SYNC = 'ENABLE_SUPPORT_INCREMENTAL_SYNC';
export const USE_LOCAL_ID_AS_SOURCED_ID = 'USE_LOCAL_ID_AS_SOURCED_ID';
export const XAPI_GRADE_SYNC = 'XAPI_GRADE_SYNC';

export const ALLOWED_FEATURE_TOGGLE_SCHEMA_MAP = new Map([
    [ROSTER_DATA_TOBEDELETED_STATUS_FEATURE_TOGGLE_KEY_NAME, [DefaultSchemaName.ONE_ROSTER_10, DefaultSchemaName.ONE_ROSTER_11, DefaultSchemaName.ONE_ROSTER_12]]
]);

export const ALLOWED_ONLY_FOR_SSO_APPS_FEATURE_TOGGLES_MAP = new Map([
    [ORG_HOST_FOR_SSO_LINK_FEATURE_TOGGLE_KEY_NAME, true]
]);

export const GRADEBOOK_SYNC_FEATURE_TOGGLE_AUTO_TURNED_ON_SYNC_APPS = [
    DataSourceFriendlyName.PowerSchool,
    DataSourceFriendlyName.Skyward,
    DataSourceFriendlyName['Skyward (OneRoster)'],
    DataSourceFriendlyName['Infinite Campus'],
    DataSourceFriendlyName['Aeries (OneRoster)']
];

export const ALLOWED_ONLY_IF_EXISTS_SOME_APPS_FEATURE_TOGGLES_MAP = new Map([
    [ENABLE_CATEGORIES_CREATION_KEY_NAME, [DataSourceType.Blackboard]]
]);

export const DENIED_TO_TURN_OFF_FEATURE_TOGGLES_WARNING_MESSAGE = '\nWARNING: Once enabled, this cannot be disabled.';

export const DENIED_TO_TURN_OFF_FEATURE_TOGGLES = [
    AUTO_PROVISION_ALLOWED_FOR_VENDOR,
    USE_LOCAL_ID_AS_SOURCED_ID
];

export const SHOW_DISTRICT_FEATURE_TOGGLE_ON_DISTRICT_APPLICATION_LEVEL = [
    // XAPI_GRADE_SYNC
];
